import { accommodationSubTypeZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type";
import {
    accommodationTypeIdFactory,
    accommodationTypeIdZodSchema,
} from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type-id";
import { capacityZodObject } from "@@/shared/acquire/resources/resource-accommodation/capacity";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
const accommodationTypeZodObject = z.object({
    _id: accommodationTypeIdZodSchema,
    _type: z.literal("ACCOMMODATION_TYPE"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    _hash: z.string(),
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString.optional(),
    shortDescription: translatableZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    subTypes: z.array(accommodationSubTypeZodObject).optional(),
    capacity: capacityZodObject,
});

type AccommodationType = z.infer<typeof accommodationTypeZodObject>;

const _accommodationTypeFactoryParamsZodObject = accommodationTypeZodObject
    .omit({
        _id: true,
        _type: true,
        _createdAt: true,
    })
    .and(
        z.object({
            _id: accommodationTypeIdZodSchema.optional(),
        }),
    );
type FactoryParams = z.infer<typeof _accommodationTypeFactoryParamsZodObject>;
const accommodationTypeFactory = (params: FactoryParams): AccommodationType => {
    return {
        ...params,
        _id: params._id ?? accommodationTypeIdFactory(),
        _type: "ACCOMMODATION_TYPE",
        _createdAt: nowIsoAndUnix(),
    };
};

const isAccommodationType = (value: unknown): value is AccommodationType => {
    return accommodationTypeZodObject.safeParse(value).success;
};

export {
    accommodationTypeFactory,
    accommodationTypeZodObject,
    isAccommodationType,
};
export type { AccommodationType };
